import React, { useState } from "react";
import "./Header.css";
import Logo from "./5YNOW.svg";
import LIC from "./Lic.svg";

function Header(props) {
  const [showList, setShowList] = useState(false);
  return (
    <div>
      <div className="header">
        <img src={Logo} className="lg" />
        <h1 className="heading">5YNOW</h1>
        <img src={LIC} className="lic" onClick={()=>{setShowList(!showList)}}/>
      </div>
      {showList ? (
        <div className="list">
          <img
            src="https://www.tenforums.com/attachments/user-accounts-family-safety/322690d1615743307t-user-account-image-log-user.png"
            className="pro-img"
          />
          <div>
            <div className="ell">Points : {props.points}</div>
            <div className="ell">Home</div>
            <div className="ell">Env Home</div>
            <div className="ell">Health Home</div>
            <div className="ell">Signout</div>
          </div>
        </div>
      ) : (
        <noscript />
      )}
    </div>
  );
}

export default Header;
